/**
 * CONTROLE DA BARRA DE PESQUISA EXPANSÍVEL
 * Gerencia a abertura e fechamento da barra de pesquisa
 */

class SearchExpandable {
  constructor() {
    this.searchToggle = document.querySelector('[data-search-toggle]');
    this.searchExpandable = document.querySelector('[data-search-expandable]');
    this.searchClose = document.querySelector('[data-search-close]');
    this.searchInput = document.querySelector('#Search-Expandable');
    this.isActive = false;
    
    this.init();
  }

  init() {
    if (!this.searchToggle || !this.searchExpandable) return;
    
    // Event listeners
    this.searchToggle.addEventListener('click', () => this.openSearch());
    this.searchClose.addEventListener('click', () => this.closeSearch());
    
    // Fechar com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isActive) {
        this.closeSearch();
      }
    });
    
    // Fechar ao clicar fora
    document.addEventListener('click', (e) => {
      if (this.isActive && 
          !this.searchExpandable.contains(e.target) && 
          !this.searchToggle.contains(e.target)) {
        this.closeSearch();
      }
    });
    
    // Focar no input quando abrir
    this.searchExpandable.addEventListener('transitionend', () => {
      if (this.isActive) {
        this.searchInput.focus();
      }
    });
  }

  openSearch() {
    if (this.isActive) return;
    
    this.isActive = true;
    this.searchExpandable.classList.add('is-active');
    this.searchToggle.setAttribute('aria-expanded', 'true');
    
    // Focar no input após a animação
    setTimeout(() => {
      this.searchInput.focus();
    }, 300);
  }

  closeSearch() {
    if (!this.isActive) return;
    
    this.isActive = false;
    this.searchExpandable.classList.remove('is-active');
    this.searchToggle.setAttribute('aria-expanded', 'false');
    
    // Limpar o input
    this.searchInput.value = '';
  }
}

// Inicializar quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
  new SearchExpandable();
});

// Também inicializar se o script for carregado após o DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SearchExpandable();
  });
} else {
  new SearchExpandable();
} 